// ===== EDITE AQUI: links externos do app =====
export const APP_LINKS = {
  appStore: "https://apps.apple.com/br/app/tryvitta-fitness/id6758320131",
  playStore: "https://play.google.com/store/apps/details?id=com.converta.femmetryvitta&pcampaignid=web_share",
};

// ===== EDITE AQUI: URL do vídeo do hero (mp4 local ou link do YouTube). Deixe "" para ocultar o botão =====
export const LOGO_URL = "/assets/logo-tryvitta.jpeg";

// ===== EDITE AQUI: versão web do app e ID do Google Analytics 4 (ex: "G-XXXXXXX") =====
export const WEBAPP_URL = "https://femme.tryvitta.com.br";
export const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID || "";

// ===== EDITE AQUI: números e destaques da prova social =====
export const SOCIAL_PROOF = [
  { type: "stat", text: "+1.000 usuários transformando a rotina" },
  { type: "stat", text: "+5.000 exercícios na biblioteca" },
  { type: "stat", text: "+5.000 refeições diferentes geradas por IA" },
  { type: "mode", text: "Modo Canetinha: treino e dieta para quem usa GLP-1" },
  { type: "mode", text: "Modo Ciclo Menstrual: plano adaptado a cada fase" },
];

// ===== EDITE AQUI: planos e preços =====
export const PRICING = [
  {
    id: "mensal",
    name: "Mensal",
    price: "R$ 39,90",
    period: "/mês",
    note: "Cobrança mensal no cartão · renovação automática",
    tag: null,
    highlight: false,
  },
  {
    id: "trimestral",
    name: "Trimestral",
    price: "R$ 29,97",
    period: "/mês",
    note: "Total R$ 89,90 a cada 3 meses · renovação automática",
    savings: "Economize 25%",
    tag: null,
    highlight: false,
  },
  {
    id: "semestral",
    name: "Semestral",
    price: "R$ 26,67",
    period: "/mês",
    note: "Total R$ 160,00 a cada 6 meses · renovação automática",
    savings: "Economize 33%",
    tag: null,
    highlight: false,
  },
  {
    id: "anual",
    name: "Anual",
    price: "R$ 24,99",
    period: "/mês",
    note: "Total R$ 299,90 por ano · de R$ 478,80",
    savings: "Economia de R$ 178,90",
    tag: "Melhor economia",
    highlight: true,
  },
];

export const PLAN_FEATURES = [
  "5 dias grátis para testar tudo",
  "Coach com IA, Slim, nutrição e treinos liberados",
  "Cancele quando quiser, sem multa",
];

// ===== EDITE AQUI: perguntas frequentes =====
export const FAQS = [
  {
    q: "Preciso de academia para usar o TryVitta?",
    a: "Não. O app monta treinos para casa e para academia. Você escolhe onde treinar e o app se adapta ao seu espaço e equipamento.",
  },
  {
    q: "Como funciona o teste de 5 dias?",
    a: "Ao baixar o app, você tem 5 dias de acesso completo a todas as funcionalidades, sem precisar de cartão. Depois, escolha o plano que faz sentido para você.",
  },
  {
    q: "Posso usar o TryVitta Slim sem usar medicamento?",
    a: "Sim. O Slim é um programa completo de emagrecimento com acompanhamento de hábitos, nutrição e bem-estar. O Modo Canetinha é um adicional exclusivo para quem usa GLP-1.",
  },
  {
    q: "Como cancelo a assinatura?",
    a: "Direto no app, em 2 toques. Sem ligação, sem e-mail, sem burocracia — e sem multa.",
  },
  {
    q: "O app funciona offline?",
    a: "Você pode visualizar treinos e cardápios offline. Para registrar refeições por foto e conversar com o coach, precisa de internet.",
  },
  {
    q: "Os coaches de IA substituem profissionais?",
    a: "Não. Eles são um acompanhamento diário complementar. Sempre consulte médico, nutricionista e personal trainer para orientação profissional.",
  },
  {
    q: "Tem versão para profissionais?",
    a: "Sim. Personal trainers e nutricionistas usam o painel TryVitta Pro para acompanhar alunos e montar planos. Acesse a página Para Profissionais no rodapé.",
  },
];

// ===== EDITE AQUI: depoimentos (EXEMPLOS do briefing — trocar por cases reais com autorização) =====
export const TESTIMONIALS = [
  {
    initials: "M",
    name: "Mariana, 28 — São Paulo",
    result: "-8 kg em 3 meses com o TryVitta Slim",
    quote:
      "O coach Maya me ajudou a manter a constância. Nunca me senti sozinha na jornada.",
  },
  {
    initials: "R",
    name: "Rodrigo, 35 — Rio de Janeiro",
    result: "58 dias seguidos de treino",
    quote:
      "A análise de exames me mostrou o que precisava mudar. Hoje durmo melhor e tenho mais energia.",
  },
  {
    initials: "C",
    name: "Camila, 31 — Belo Horizonte",
    result: "+4 kg de massa em 4 meses",
    quote:
      "Os treinos se adaptam ao meu dia. Quando não posso ir à academia, o app monta treino em casa.",
  },
];

// ===== EDITE AQUI: números do bloco de estatísticas =====
export const STATS = [
  { value: "+1.000", label: "usuários ativos" },
  { value: "+5.000", label: "exercícios na biblioteca" },
  { value: "+5.000", label: "refeições geradas por IA" },
  { value: "8", label: "coaches de IA" },
];

// ===== EDITE AQUI: perguntas do quiz de personalização =====
export const QUIZ_QUESTIONS = [
  {
    id: "objective",
    title: "Qual é seu principal objetivo?",
    options: [
      { value: "emagrecer", label: "Emagrecer", icon: "flame" },
      { value: "massa", label: "Ganhar massa muscular", icon: "dumbbell" },
      { value: "definir", label: "Ficar mais definido", icon: "medal" },
      { value: "saude", label: "Melhorar minha saúde", icon: "heart" },
      { value: "disposicao", label: "Melhorar minha disposição", icon: "zap" },
    ],
  },
  {
    id: "days",
    title: "Quantos dias por semana você consegue treinar?",
    options: [
      { value: "2", label: "2 dias", icon: "calendar" },
      { value: "3", label: "3 dias", icon: "calendar" },
      { value: "4", label: "4 dias", icon: "calendar" },
      { value: "5", label: "5 dias", icon: "calendar" },
      { value: "6+", label: "6+ dias", icon: "calendar" },
    ],
  },
  {
    id: "place",
    title: "Onde você costuma treinar?",
    options: [
      { value: "academia", label: "Academia", icon: "building" },
      { value: "casa", label: "Em casa", icon: "home" },
      { value: "hibrido", label: "Academia + casa", icon: "shuffle" },
      { value: "nenhum", label: "Ainda não treino", icon: "sprout" },
    ],
  },
  {
    id: "obstacle",
    title: "O que mais atrapalha sua evolução?",
    options: [
      { value: "alimentacao", label: "Minha alimentação", icon: "salad" },
      { value: "tempo", label: "Falta de tempo", icon: "clock" },
      { value: "disciplina", label: "Falta de disciplina", icon: "repeat" },
      { value: "direcao", label: "Não sei o que fazer", icon: "compass" },
      { value: "constancia", label: "Começo e paro", icon: "rotate" },
    ],
  },
];
